import { render, staticRenderFns } from "./overviewInfo.vue?vue&type=template&id=f256896e&scoped=true&"
import script from "./overviewInfo.vue?vue&type=script&lang=js&"
export * from "./overviewInfo.vue?vue&type=script&lang=js&"
import style0 from "./overviewInfo.vue?vue&type=style&index=0&id=f256896e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f256896e",
  null
  
)

export default component.exports